import { render, staticRenderFns } from "./video.vue?vue&type=template&id=4b8b3cc6&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
import style0 from "./video.vue?vue&type=style&index=0&id=4b8b3cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b3cc6",
  null
  
)

export default component.exports